import { Action, Channel } from 'redux-saga';
import { HydrateAction, hydrateType } from '../../HydrateAction';
import { SagaGenerator, actionChannel, call, take } from 'typed-redux-saga';
import trackSessionActions, {
  SessionActionType,
  TrackSessionActionsType
} from '../../../tracking/trackSessionActions';
import { CartTypeQuantityData } from '../../../tracking/pushToDataLayer';
import { OptionalStateCarts } from '../../carts/CartsState';
import { calculateCartQuantities } from '../../../tracking/calculateCartQuantities';
import { logout } from '../../auth/authSlice';

function* handleCartStateChanges(
  cartQuantityData: CartTypeQuantityData,
  anonymousUserId: string | null,
  authenticatedUserId: string | null
): SagaGenerator<void> {
  const actionType: TrackSessionActionsType = { type: SessionActionType.LOGOUT };

  yield* call(
    trackSessionActions,
    actionType,
    anonymousUserId,
    authenticatedUserId,
    cartQuantityData
  );
}

function* watchLogoutActionTrackingSaga(): SagaGenerator<void> {
  const hydrateAction: Channel<HydrateAction> = yield* actionChannel<HydrateAction>([hydrateType]);
  const logoutAction: Channel<Action> = yield* actionChannel<Action>(logout);
  let latestHydrationAction = null;
  while (true) {
    latestHydrationAction = yield* take(hydrateAction);
    yield* take(logoutAction);

    const { auth, carts, session } = latestHydrationAction.payload;
    if (!carts || !session || !auth) {
      continue;
    }
    const currentCartState: OptionalStateCarts = carts.carts;
    const anonymousUserId: string | null = session.content?.guid ?? null;
    const authenticatedUserId: string | null = auth.authenticatedUserId;
    const cartQuantityData = calculateCartQuantities(currentCartState);

    yield* handleCartStateChanges(cartQuantityData, anonymousUserId, authenticatedUserId);
  }
}

export default watchLogoutActionTrackingSaga;
